import { z } from "zod";

export const renameDocumentFormSchema = z.object({
	title: z.string().trim().min(1),
});

export type RenameDocumentFormInput = z.input<typeof renameDocumentFormSchema>;
export type RenameDocumentFormOutput = z.output<
	typeof renameDocumentFormSchema
>;
